export enum EModeVariant {
  Dark = 'dark',
  Light = 'light',
}
